export const COLOR_INDEX = {
    BLACK: 0,
    RED: 1,
    BLUE: 2
}

export const TOOL_INDEX = {
    EDIT: 0,
    TEXT: 1,
    ERASE: 2,
    SELECT: 3
}